export const PAYSLIP_SEND_AFTER_LOAD = 'PAYSLIP_SEND_AFTER_LOAD'
export const PAYSLIP_SEND_AFTER_LOAD_PENDING = 'PAYSLIP_SEND_AFTER_LOAD_PENDING'
export const PAYSLIP_SEND_AFTER_LOAD_FULFILLED = 'PAYSLIP_SEND_AFTER_LOAD_FULFILLED'
export const PAYSLIP_SEND_AFTER_LOAD_REJECTED = 'PAYSLIP_SEND_AFTER_LOAD_REJECTED'

export const PAYSLIP_SEND_AFTER_UPDATE = 'PAYSLIP_SEND_AFTER_UPDATE'
export const PAYSLIP_SEND_AFTER_UPDATE_PENDING = 'PAYSLIP_SEND_AFTER_UPDATE_PENDING'
export const PAYSLIP_SEND_AFTER_UPDATE_FULFILLED = 'PAYSLIP_SEND_AFTER_UPDATE_FULFILLED'
export const PAYSLIP_SEND_AFTER_UPDATE_REJECTED = 'PAYSLIP_SEND_AFTER_UPDATE_REJECTED'
